import {
  MCP_TOOLS,
  MCP_TOOLS_PRICING_INFORMATION,
} from "@flowstepdesign/shared";

import { MCP_SERVER_URL, MCP_TOOL_COUNT } from "./mcpServer";

// Answers the hub page publishes as FAQPage structured data. Each one is
// written to stand alone if an answer engine quotes it without the page.
export const HUB_FAQS = [
  {
    question: "What is the Flowstep MCP server?",
    answer: `The Flowstep MCP server is a remote Model Context Protocol server at ${MCP_SERVER_URL}. It exposes ${MCP_TOOL_COUNT} Flowstep tools for generating screens, editing them, rendering them as images, and managing files and their instructions. Any MCP client can call them, so an AI agent can produce real, editable UI instead of describing one.`,
  },
  {
    question: "Which MCP clients does Flowstep work with?",
    answer:
      "Any client that supports remote HTTP MCP servers. Flowstep publishes step-by-step setup for Claude Code, Cursor, Claude, Windsurf and Codex. Other clients work with the same URL and OAuth flow.",
  },
  {
    question: "Do I need an API key?",
    answer:
      "No. The server uses OAuth 2.0 with PKCE. The first time your client calls a Flowstep tool it opens a browser, you sign in with your Flowstep account, and the client stores the token itself. There is no key to generate, paste or rotate.",
  },
  {
    question: "Is it free?",
    answer: `The server is included with every Flowstep account, including the free plan. ${MCP_TOOLS_PRICING_INFORMATION} Call ${MCP_TOOLS.getPlanDetails.name} for your plan, usage, and remaining quota.`,
  },
  {
    question: "Can an agent see the designs it makes?",
    answer: `Yes. ${MCP_TOOLS.getScreenImage.name} renders any screen to a PNG and returns it inline to your agent if configured, so your agent sees the actual output rather than its own description of it.`,
  },
  {
    question: "Do screens made over MCP appear in the Flowstep app?",
    answer:
      "Immediately. There is one account and one canvas. A screen an agent generates from your terminal is the same object your teammate opens in the browser, edits, and copies into Figma.",
  },
  {
    question: "What is the difference between this and the Figma MCP server?",
    answer: `Both can create designs, so this is not a read-versus-write split. The difference is where the output lives. Flowstep puts screens on the Flowstep canvas, where they stay editable, export as React, TypeScript and Tailwind, or copy straight into Figma. If a design already exists in Figma, ${MCP_TOOLS.importFigma.name} brings that frame onto the canvas as editable elements so you can generate the states around it. Running both servers together is fine.`,
  },
  {
    question: "Can I revoke access?",
    answer:
      "Yes. Remove the server in your client's config, or revoke the session on the Flowstep side, which signs out every connected client at once. No long-lived key is left behind.",
  },
];
